<script>
import { Icon } from "vant";
import DateTimePicker from "@/components/date-time-picker/function";
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "DateRangePicker",
  components: {
    [Icon.name]: Icon,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    defaultValue: {
      type: Array,
      default: () => [],
    },
    min: {
      type: String,
      default: "",
    },
    max: {
      type: String,
      default: "",
    },
    prop: {
      type: Object,
      default: () => {},
    },
    limitMaxDate: {
      type: String,
      default: "",
    },
    disabled: {
      type: Object,
      default() {
        return {
          disabledStart: false,
          disabledEnd: false,
        };
      },
    },
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      minDate: "",
      maxDate: "",
      minLimit: "",
    };
  },
  watch: {
    value(val) {
      this.startDate = val[0];
      this.endDate = val[1];
    },
    min(val) {
      this.minDate = val;
    },
    max(val) {
      this.maxDate = val;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.copyData();
      if (this.defaultValue && this.defaultValue.length > 1) {
        this.startDate = this.defaultValue[0];
        this.endDate = this.defaultValue[1];
        this.$emit("update:value", this.defaultValue);
      }
      this.minDate = this.min;
      this.maxDate = this.max;
      this.minLimit = this.min ? this.min : new Date();
    },
    handleStartDateClick(/*type*/) {
      if (this.disabled.disabledStart) {
        return false;
      }
      const startDisabled = this.prop && this.prop.startDisabled;
      if (!startDisabled) {
        const that = this;
        DateTimePicker({
          value: that.startDate,
          format: "YYYY-MM-DD",
          minDate: that.minDate,
          maxDate: that.maxDate,
          change: that.setStartDate,
        });
      }
    },
    handleEndDateClick(/*type*/) {
      if (this.disabled.disabledEnd) {
        return false;
      }
      const endDisabled = this.prop && this.prop.endDisabled;
      if (!endDisabled) {
        const that = this;
        DateTimePicker({
          value: that.endDate,
          format: "YYYY-MM-DD",
          minDate: that.startDate,
          maxDate: this.limitMaxDate ? that.limitMaxDate : "",
          change: that.setEndDate,
        });
      }
    },
    setStartDate(value) {
      this.startDate = value;
      // this.minDate = value;
      // this.maxDate = this.maxDate;
      this.updateData("start");
    },
    setEndDate(value) {
      this.endDate = value;
      // this.minDate = this.minDate;
      // this.maxDate = value;
      this.updateData("end");
    },
    setValue(value) {
      this.copyData(value);
    },
    copyData(val) {
      const value = val ? val : this.value;
      const dates = cloneDeep(value);
      if (dates && dates.length > 1) {
        this.startDate = dates[0];
        this.endDate = dates[1];
      } else {
        this.startDate = "";
        this.endDate = "";
      }
    },
    updateData(status) {
      const json = [];
      if (this.startDate) {
        json.push(this.startDate);
      }
      if (this.endDate) {
        json.push(this.endDate);
      }
      this.$emit("update:value", json);
      this.$emit("change", json, status);
    },
  },
  render() {
    const startLable = this.prop && this.prop.startLabel;
    const endLable = this.prop && this.prop.endLabel;
    let fh = <div class="fh"> - </div>;
    if (this.prop && this.prop.seperate == false) {
      fh = "";
    }
    return (
      <div class="date-range-picker">
        <div class="date-label">{startLable}</div>
        <div
          class={
            this.disabled.disabledStart
              ? "item disabled start-date"
              : "item start-date"
          }
          {...{ on: { click: this.handleStartDateClick } }}
        >
          <van-icon class="item-icon" name="calender-o" />
          {this.startDate}
        </div>
        {fh}
        <div class="date-label">{endLable}</div>
        <div
          class={
            this.disabled.disabledEnd
              ? "item disabled end-date"
              : "item end-date"
          }
          {...{ on: { click: this.handleEndDateClick } }}
        >
          <van-icon class="item-icon" name="calender-o" />
          {this.endDate}
        </div>
      </div>
    );
  },
};
</script>

<style lang="less" scoped>
.date-range-picker {
  display: flex;
  font-size: 14px;
  .item {
    flex: 1;
    padding: 0.1rem 0.2rem;
    background: #f1f1f1;
    border-radius: 4px;
    margin-left: 3px;
    .item-icon {
      margin-right: 6px;
    }
    &.disabled {
      color: #999;
    }
  }
  .fh,
  .date-label {
    // padding: 0 10px;
    line-height: 30px;
  }
}
</style>
